export default "__VITE_ASSET__c1992cf0__"